import React from "react";
import classes from "./record.module.scss";

const DAY = 86400000;

const parse = (value: string | Date | null | undefined): Date | null => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

/** "today", "6 days ago", or the date once it is more than a month old. */
export const recentOrDate = (value: string | Date | null | undefined): string => {
    const date = parse(value);
    if (!date) return typeof value === "string" ? value : "";
    const days = Math.floor((Date.now() - date.getTime()) / DAY);
    if (days <= 0) return "today";
    if (days === 1) return "yesterday";
    if (days < 31) return `${days} days ago`;
    return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

const fullDate = (value: string | Date | null | undefined): string | undefined => {
    const date = parse(value);
    return date ? date.toLocaleString("en-GB", { dateStyle: "full", timeStyle: "short" }) : undefined;
};

interface RecordFooterProps {
    createdAt?: string | Date | null;
    createdBy?: string | null;
    updatedAt?: string | Date | null;
    updatedBy?: string | null;
    /** Trailing links / buttons — "Change log", "Previous contacts". */
    extra?: React.ReactNode;
}

/** "Created 7 May 2026 by Asem · Updated 6 days ago · Change log". */
const RecordFooter: React.FC<RecordFooterProps> = ({ createdAt, createdBy, updatedAt, updatedBy, extra }) => {
    const created = recentOrDate(createdAt);
    const updated = recentOrDate(updatedAt);
    if (!created && !updated && !extra) return null;
    return (
        <footer className={classes.footer}>
            {created && (
                <span title={fullDate(createdAt)}>
                    Created {created}{createdBy ? ` by ${createdBy}` : ""}
                </span>
            )}
            {updated && (
                <span title={fullDate(updatedAt)}>
                    Updated {updated}{updatedBy ? ` by ${updatedBy}` : ""}
                </span>
            )}
            {extra}
        </footer>
    );
};

export default RecordFooter;
